export const isLogin = ({auth}) => auth;
